import { Icon, IconProps, ProgressBar } from '@ets/design-system';

import { FormattedMessage } from 'react-intl';

import styles from './Loading.module.scss';

type LoadingProps = Omit<IconProps, 'size'> &
  Partial<Pick<IconProps, 'size'>> & {
    message: TranslationMessage;
  };

const Loading = ({ message, size = '12', ...iconProps }: LoadingProps) => {
  return (
    <div className={styles.loading}>
      {iconProps.icon && (
        <span className={styles.icon}>
          <Icon size={size} {...iconProps} />
        </span>
      )}

      <ProgressBar variant="primary-light" size="m" testId="import-new-version-importing" />

      <span className={styles.message}>
        <FormattedMessage id={message.id} values={message.values} />
      </span>
    </div>
  );
};

export default Loading;
